import { useState, useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import SelectCustomFieldPopout from 'components/SelectCustomFieldPopout';
import CustomFieldName from 'components/CustomFieldName';
import CustomFieldIcon from 'components/CustomFieldIcon';
import Select from 'components/select';

import IconArrowDown from 'icons/icon-arrow-down';

import './CustomFieldCalcEditor.styles.css';

const DEFAULT_EXPRESSION = [
    {
        operator: 'add',
        fieldId: null
    },
    {
        operator: 'add',
        fieldId: null
    }
];

const OPERATORS = [
    {
        id: 'add',
        text: '+'
    },
    {
        id: 'subtract',
        text: '−'
    },
    {
        id: 'multiply',
        text: '×'
    },
    {
        id: 'divide',
        text: '÷'
    }
];

const OperatorSelect = ({ value, onChange }) => {
    return (
        <div className="operator-select">
            <Select
                dropdownClassname="operator-select-dropdown"
                small={true}
                selected={value}
                options={OPERATORS}
                onChange={onChange}
            />
        </div>
    )
}

const FieldSelect = ({ association, projectId, value, onChange }) => {
    const { t } = useTranslation('fields');

    return (
        <SelectCustomFieldPopout
            selected={value}
            projectId={projectId}
            association={association}
            xAlign="left"
            defaultXPosition="right"
            title={ t('types.calc.selectField.popoutTitle') }
            onSelect={onChange}
        >
            <div className="select small">
                <div className="select-toggle">

                    <div className="selection">
                        { value ? <CustomFieldIcon id={value} /> : null }

                        { value ? <CustomFieldName id={value} /> : t('types.calc.selectField.placeholder') }
                    </div>

                    <span className="arrow">
                        <IconArrowDown />
                    </span>
                </div>
            </div>
        </SelectCustomFieldPopout>
    )
}

const ExpressionEntry = ({ association, projectId, index, fieldId, operator, isFirst, onChange }) => {
    const handleOperatorChange = useCallback(({ id: operator }) => {
        onChange(index, { operator, fieldId });
    }, [index, fieldId, onChange]);

    const handleFieldIdChange = useCallback(fieldId => {
        onChange(index, { operator, fieldId });
    }, [index, operator, onChange]);

    return (
        <div className="expression-entry">
            {
                !isFirst ? <OperatorSelect value={operator} onChange={handleOperatorChange} /> : null
            }

            <FieldSelect association={association} projectId={projectId} value={fieldId} onChange={handleFieldIdChange} />
        </div>
    );
}

const CustomFieldCalcEditor = ({ association, projectId, expression = DEFAULT_EXPRESSION, onChange }) => {
    const { t } = useTranslation('fields');
    const [expressionState, setExpressionState] = useState(expression);

    const handleEntryChange = useCallback((index, newEntry) => {
        const nextState = [...expressionState];

        nextState[index] = newEntry;

        setExpressionState(nextState);

        onChange(nextState);
    }, [expressionState, onChange]);
    return (
        <div className="form-row">
            <div className="field-label">
                { t('types.calc.title') }
            </div>

            <div className="custom-field-calc-editor">
                {
                    expressionState.map(({ fieldId, operator }, index) => <ExpressionEntry key={index} index={index} association={association} projectId={projectId} fieldId={fieldId} operator={operator} isFirst={index === 0} onChange={handleEntryChange} />)
                }
            </div>
        </div>
    );
}

export default CustomFieldCalcEditor;
